import { UserSimple } from 'src/types/userSimple';

export function getAccessToken(): any {
  try {
    return JSON.parse(localStorage.getItem('accessToken') || 'null');
  } catch (e) {
    console.error('Failed to parse accessToken:', e);
    return null;
  }
}

export function userHasRole(roles: string[]): boolean {
  try {
    const { applications } = getAccessToken();
    const application = applications?.find((app: any) => app.applicationName === 'SFA');
    const applicationRoles = application?.roles?.map((role: any) => role.name) || [];

    return roles.some((role: string) => applicationRoles.includes(role));
  } catch (e) {
    console.error('Failed to find role in userHasRole helper function:', e);
    return false;
  }
}

export function getUniqueUsersByUsername(users: UserSimple[], preferredCompanyUserId?: number): UserSimple[] {
  const usersByUsername = new Map<string, UserSimple>();

  users.forEach((user) => {
    const username = user.username.trim().toLowerCase();
    if (!username) {
      return;
    }

    const existing = usersByUsername.get(username);
    if (!existing || user.companyUserId === preferredCompanyUserId) {
      usersByUsername.set(username, user);
    }
  });

  return Array.from(usersByUsername.values()).sort((a, b) => a.username.localeCompare(b.username));
}

export function getUsernameByCompanyUserId(users: UserSimple[], companyUserId?: number | null): string {
  if (!companyUserId) {
    return '';
  }

  return users.find((user) => user.companyUserId === companyUserId)?.username || String(companyUserId);
}
